import { name } from './name';
import { type } from './type';
import { namespace } from './namespace';
import { className } from './className';
import { ingressRules } from './ingressRules';
import { created } from './created';

export const columns = [
  name,
  namespace,
  className,
  type,
  ingressRules,
  created,
];
